import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

/**
 * Approval status badge — mirrors the shared `approval_status` enum from
 * `docs/specs/03-database-spec.md` §3. Phase 2 review (P1-#3) replaced the
 * legacy {pending, withdrawn} pair with the canonical DB values.
 */
export type ApprovalStatus =
  | 'draft'
  | 'pending_approval'
  | 'approved'
  | 'rejected'
  | 'retired'
  | 'superseded';

interface Props {
  status: ApprovalStatus;
  className?: string;
}

const toneClass: Record<ApprovalStatus, string> = {
  draft: 'bg-efs-bg-subtle text-efs-text-muted',
  pending_approval: 'efs-bg-warning',
  approved: 'efs-bg-success',
  rejected: 'efs-bg-error',
  retired: 'bg-efs-bg-subtle text-efs-text-muted',
  superseded: 'bg-efs-bg-subtle text-efs-text-muted',
};

export const ApprovalStatusBadge = ({ status, className }: Props) => {
  const { t } = useTranslation();
  const label = t(`efs.common.status.${status}`, { defaultValue: status });
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium uppercase tracking-wide',
        toneClass[status],
        className,
      )}
    >
      {label}
    </span>
  );
};
